import { Heading, Stack, Text } from "@caspeco/casper-ui-library";
import { useWebBooking } from "api/api-hooks/use-web-booking";
import { useTranslation } from "react-i18next";

interface GreetingProps {
    name: string;
    isWaitList: boolean;
    isInquiry: boolean;
}

export default function Greeting({ name, isWaitList, isInquiry }: GreetingProps) {
    const { t } = useTranslation();
    const webBooking = useWebBooking().data;

    const getMessage = () => {
        if (isWaitList) {
            return t("waitList.waitListDetailsMessage");
        }

        if (webBooking?.isInquiryProposal()) {
            return t("bookingRequest.viewProposal.message");
        }

        if (isInquiry) {
            return t("bookingRequest.viewRequest.message");
        }
        return t("viewBookingDetails");
    };
    return (
        <Stack
            alignItems="flex-start"
            justifyContent="space-between"
            flexDirection="column"
            style={{ height: "100%" }}
        >
            <div>
                <Heading as={"h1"} fontWeight="700" color="inherit">
                    {t("hi")} {name},
                </Heading>
                <Text maxW="440">{getMessage()}</Text>
            </div>
        </Stack>
    );
}
